import { render } from "./Badge.vue?vue&type=template&id=62f69c1f&scoped=true&ts=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"

import "./Badge.vue?vue&type=style&index=0&id=62f69c1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f69c1f"]])

export default __exports__